import { withOnlineTileTimeout } from "./webgl-maplibre.online-tiles";
import { addProtocol } from "maplibre-gl";

const prefix = "efb-aero://";
let registered = false;
const blankPng = "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVR4nGNgAAIAAAUAAXpeqz8AAAAASUVORK5CYII=";

/** Absent aero tiles represent empty coverage, not a request for parent imagery. */
export async function loadAeroTile(url: string, signal: AbortSignal): Promise<{ data: ArrayBuffer }> {
  if (/^https?:\/\//.test(url) && !["localhost", "127.0.0.1", "[::1]"].includes(new URL(url).hostname)) {
    return withOnlineTileTimeout(signal, (boundedSignal) => readAeroTile(url, boundedSignal));
  }
  return readAeroTile(url, signal);
}

async function readAeroTile(url: string, signal: AbortSignal): Promise<{ data: ArrayBuffer }> {
  const response = await fetch(url, { signal });
  if (response.status === 404 || response.status === 204) {
    return { data: Uint8Array.from(atob(blankPng), (c) => c.charCodeAt(0)).buffer };
  }
  if (!response.ok) throw new Error(`Aero tile request failed (${response.status}): ${url}`);
  return { data: await response.arrayBuffer() };
}

export function aeroTileUrl(url: string): string {
  if (!registered) {
    addProtocol("efb-aero", (params, controller) => loadAeroTile(params.url.slice(prefix.length), controller.signal));
    registered = true;
  }
  return prefix + url;
}
